import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IconButton } from "@mui/material";
import deleteIcon from '../../assets/images/deleteIcon_drawer.svg';
import { getPracticeLocations } from "../../actions/userActions/practiceLocationAction";
import { toast } from 'react-toastify';
import SingleSelect from "../designSystem/SingleSelect";
import MultiSelect from "../designSystem/MultiSelect";
import { t } from "../../locales/translate";
import "../reuse_components/LocationFieldsTile.css";

function Doctorpracticelocationrow(props) {
    const [cityPracticeLocations, setCityPracticeLocations] = useState({});
    const [loadingCities, setLoadingCities] = useState({});
    const dispatch = useDispatch();

    const cities = useSelector((state) => state.cities_reducer.cities);
    const fetchedPracticeLocations = useSelector((state) => state.practiceLocations_reducer.practiceLocations);
    
    useEffect(() => {
    if (fetchedPracticeLocations && fetchedPracticeLocations !== "isLoading" && fetchedPracticeLocations?.result) {
        const locations = fetchedPracticeLocations?.result;
        if (locations && locations.length > 0) {
            const cityId = locations[0].city;
            setCityPracticeLocations(prev => ({
                ...prev,
                [cityId]: locations
            }));
            setLoadingCities(prev => ({
                ...prev,
                [cityId]: false
            }));
        } else {
            setLoadingCities(prev => {
                const updated = { ...prev };
                Object.keys(updated).forEach(cityId => {
                    if (updated[cityId] === true) {
                        updated[cityId] = false;
                    }
                });
                return updated;
            });
        }
    }
}, [fetchedPracticeLocations]);

    const handleRowChange = (rowIndex, field, value) => {
        if (field === "cityId") {
            const locationAlreadyExists = props.formValues.rows.some(
                (row, index) => index !== rowIndex && row.cityId === value
            );

            if (locationAlreadyExists) {
                toast.error("This city already exists in another row.");
                return;
            }

            props.setFormValues((prevState) => ({
                ...prevState,
                rows: prevState.rows.map((row, index) =>
                    index === rowIndex
                        ? {
                            ...row,
                            cityId: value,
                            practiceLocationIds: []
                        }
                        : row
                ),
            }));

            if (!cityPracticeLocations[value] && !loadingCities[value]) {
                setLoadingCities(prev => ({
                    ...prev,
                    [value]: true
                }));
                
                const practiceLocationBody = {
                    pageNumber: -1,
                    filter: { textSearch: "", city: value },
                    pageSize: 0,
                };
                dispatch(getPracticeLocations(practiceLocationBody));
            }
        }
    };

    const handleMultiSelectRowChange = (rowIndex, values) => {
        props.setFormValues((prevState) => ({
            ...prevState,
            rows: prevState.rows.map((row, index) =>
                index === rowIndex
                    ? {
                        ...row,
                        practiceLocationIds: values
                    }
                    : row
            ),
        }));
    };
    const handleDeleteClick = (rowIndex) => {
        props.setFormValues((prevState) => ({
            ...prevState,
            rows: prevState.rows.filter((_, index) => index !== rowIndex)
        }));
    };
    const getOptions = (type, cityId) => {
        if (type === "cities") {
            return cities?.result
                ?.sort((a, b) => a.name.localeCompare(b.name))
                .map((city) => ({
                    value: city.id,
                    label: city.name,
                })) || [];
        }

        if (type === "practiceLocations") {
            const locationsForCity = cityPracticeLocations[cityId] || [];
            return locationsForCity.map((location) => ({
                value: location.id,
                label: location.name,
            }));
        }

        return [];
    };

    useEffect(() => {
        if (props.row.cityId && props.row.cityId !== 0 && !cityPracticeLocations[props.row.cityId] && !loadingCities[props.row.cityId]) {
            setLoadingCities(prev => ({
                ...prev,
                [props.row.cityId]: true
            }));
            
            const practiceLocationBody = {
                pageNumber: -1,
                filter: { textSearch: "", city: props.row.cityId },
                pageSize: 0,
            };
            dispatch(getPracticeLocations(practiceLocationBody));
        }
    }, [props.row.cityId]);

    return (
        <>
            <div key={`${props.row.cityId}-${props.index}`} className={`mb-3 location-fields-row ${props.index > 0 ? 'has-delete' : 'no-delete'}`}>
                <div className="location-fields-tile">
                    <div className="row align-items-center">
                        <div className="col-6">
                            <SingleSelect
                                label={`${t("city")} *`}
                                isSearchable
                                secondaryLabel
                                iconEnd
                                error={props.formErrors?.rows?.[props.index]?.cityId}
                                onChange={(e) => handleRowChange(props.index, "cityId", e.value)}
                                value={props.row.cityId}
                                placeholder={t("city")}
                                options={getOptions("cities")}
                            />
                        </div>
                        <div className="col-6">
                            <MultiSelect
                                label={`${t("practiceLocation")} *`}
                                isSearchable
                                secondaryLabel
                                iconEnd
                                error={props.formErrors?.rows?.[props.index]?.practiceLocationIds}
                                onChange={(values) => handleMultiSelectRowChange(props.index, values)}
                                value={props.row.practiceLocationIds}
                                options={getOptions("practiceLocations", props.row.cityId)}
                                isLoading={loadingCities[props.row.cityId]}
                            />
                        </div>
                    </div>
                    {props.index > 0 && (
                        <div className="location-fields-remove-icon">
                            <IconButton onClick={() => handleDeleteClick(props.index)}>
                                <img src={deleteIcon} alt="Delete" />
                            </IconButton>
                        </div>
                    )}
                </div>
            </div>

        </>
    );
}

export default Doctorpracticelocationrow;